import {
    request,
} from './request.js'
// 文章评论
// 获取文章评论列表
export function GetPageList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/GetPageList',
        method: 'get',
        params: {
            Title : obj.Title,
            Content : obj.Content,
            Ip: obj.Ip,
            pageIndex : obj.pageIndex,
            pageSize : obj.pageSize,
        }
    })
}

//编辑文章评论
export function EditComments(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/Edit',
        method: 'post',
        data: data
    })
}

//批量审核评论
export function PassComments(Ids) {
	return request({
		url: '/api2/ZsbSiteAdmin/Comments/Pass',
		method: 'post',
        data:Ids
	})
}

//回复文章评论
export function ReplyComments(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/CommentReply',
        method: 'post',
        data: data
    })
}

//回复列表
export function GetReplyList(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/GetReplys',
        method: 'post',
        params: {
            id: id,
        }
    })
}

//删除评论回复
export function DeleteReply(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/DeleteReply',
        method: 'post',
        params: {
            id: id,
        }
    })
}

//批量删除评论
export function Deletes(Ids) {
    return request({
        url: '/api2/ZsbSiteAdmin/Comments/Deletes',
        method: 'post',
        data:Ids
    })
}